<template src="./index.html">
</template>
<script>
	import config from '../../../../../../../configHttp.js';
	import { getdata } from './data.js';
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
				headDatas: getdata().headDatas,
				headDatasv:getdata().headDatasv,
				headDatasvi:getdata().headDatasvi,
				headDatasvii:getdata().headDatasvii,
				radios:'',
				radio:'',
				company:config.company,
				delCells:[],
        tableDatasvData_22: [
          {
            label: "请选择",
            value: ""
          },
          {
            label: "企业开发新技术、新产品、新工艺发生的研究开发费用加计扣除（按100%加计扣除）",
            value: "企业开发新技术、新产品、新工艺发生的研究开发费用加计扣除（按100%加计扣除）"
          },
          {
            label: "企业为获得创新性、创意性、突破性的产品进行创意设计活动发生的相关费用加计扣除（按100%加计扣除）",
            value: "企业为获得创新性、创意性、突破性的产品进行创意设计活动发生的相关费用加计扣除（按100%加计扣除）"
          },
          {
            label: "一般股息红利等权益性投资收益免征企业所得税",
            value: "一般股息红利等权益性投资收益免征企业所得税"
          }
        ],
        tableDatasvData_23: [
          {
            label: "请选择",
            value: ""
          },
          {
            label: "从事国家重点扶持的公共基础设施项目（除农村饮水工程）投资经营的所得定期减免企业所得税",
            value: "从事国家重点扶持的公共基础设施项目（除农村饮水工程）投资经营的所得定期减免企业所得税"
          },
          {
            label: "从事农村饮水工程新建项目投资经营的所得定期减免企业所得税",
            value: "从事农村饮水工程新建项目投资经营的所得定期减免企业所得税"
          },
          {
            label: "从事符合条件的环境保护、节能节水项目的所得定期减免企业所得税",
            value: "从事符合条件的环境保护、节能节水项目的所得定期减免企业所得税"
          }
        ],
        tableDatasvData_28: [
          {
            label: "请选择",
            value: ""
          },
          {
            label: "符合条件的小型微利企业减免企业所得税",
            value: "符合条件的小型微利企业减免企业所得税"
          },
          {
            label: "国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税",
            value: "国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税"
          },
          {
            label: "国家鼓励的软件企业减免企业所得税",
            value: "国家鼓励的软件企业减免企业所得税"
          }
        ],
        tableDatasvData_29: [
          {
            label: "请选择",
            value: ""
          },
          {
            label: "环境保护专用设备投资抵免企业所得税",
            value: "环境保护专用设备投资抵免企业所得税"
          },
          {
            label: "节能节水专用设备投资抵免企业所得税",
            value: "节能节水专用设备投资抵免企业所得税"
          },
          {
            label: "安全生产专用设备投资抵免企业所得税",
            value: "安全生产专用设备投资抵免企业所得税"
          },
          {
            label: "环境保护专用设备数字化智能化改造投入抵免企业所得税",
            value: "环境保护专用设备数字化智能化改造投入抵免企业所得税"
          },
          {
            label: "节能节水专用设备数字化智能化改造投入抵免企业所得税",
            value: "节能节水专用设备数字化智能化改造投入抵免企业所得税"
          },
          {
            label: "安全生产专用设备数字化智能化改造投入抵免企业所得税",
            value: "安全生产专用设备数字化智能化改造投入抵免企业所得税"
          },
          {
            label: "其他专用设备投资抵免企业所得税",
            value: "其他专用设备投资抵免企业所得税"
          }
        ]
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: { 
				type: Boolean,
				default: false
			},
			tableDatasvii:{
				type: Array,
				default: [],
			},
			tableDatasvi:{
				type: Array,
				default: [],
			},
			tableDatas:{
				type: Array,
				default: [],
			},
			tableData: {
				type: Array,
				default: [],
			},
			tableDatasv:{
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {
			this.$nextTick(()=>{
				
			})
		},
		methods: {
			changetime(e){
				if(!e.sdsA_1_x_1.cellVal || e.sdsA_1_x_1.cellVal==null){
					e.sdsA_1_x_1.cellVal = ''
				}
				this.inputblur(e.sdsA_1_x_1)
			},
			inputblur(e){
				this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			yjfschange(e){
				this.$emit("yjfschange",e)
			},
			changeqiylx(){
				this.$emit("changeqiylx",this.headobj)
			},
			foraddhang(txaval,index){
				let newhh=this.tableDatasv[this.tableDatasv.length-4].hanh
				this.tableDatasv.splice(parseFloat(this.tableDatasv.length-3),0,{
					hanh:(parseFloat(newhh)+0.1).toFixed(1),
					sdsA_1_x_1: {
						cellCode: "sdsA_1_"+(parseFloat(newhh)+0.1).toFixed(1)+"_1",
						cellOldVal: "",
						cellType: "",
						cellVal: "",
						map: null
					},
					sdsA_1_x_2: {
						cellCode: "sdsA_1_"+(parseFloat(newhh)+0.1).toFixed(1)+"_2",
						cellOldVal: "",
						cellType: "",
						cellVal: "",
						map: null
					}
				})
			},
			fordelete(index){
				if(this.$notemptyandnull(this.tableDatasv[index]['sdsA_1_x_1'].id)){
					this.delCells.push(JSON.parse(JSON.stringify(this.tableDatasv[index])) )
				}
				this.tableDatasv.splice(index,1)
				this.$emit('delCellsCode',this.delCells)
			},
			headercellstyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('colSpan', 4);
							}
						});
					}else{
						return {
							display: "none"
						};
					}
				}
			},
			headercellstyles({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('colSpan', 5);
							}
						});
					}else{
						return {
							display: "none"
						};
					}
					
				}
			},
			spanmethods({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
        if (columnIndex === 1) {
          if (rowIndex === 0) {
            return {
              rowspan: 1,
              colspan: 3
            };
          } else if (rowIndex === 1) {
            return {
              rowspan: 1,
              colspan: 3
            };
          } else if (rowIndex === 2) {
            return {
              rowspan: 1,
              colspan: 3
            };
          } else if (rowIndex === 3) {
            return {
              rowspan: 1,
              colspan: 2
            };
          } else if (rowIndex === 4) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else if (rowIndex === 5) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 6) {
            return {
              rowspan: 1,
              colspan: 3
            };
          } else if (rowIndex === 7) {
            return {
              rowspan: 1,
              colspan: 3
            };
          }
        } else if (columnIndex === 2) {
          if (rowIndex === 0) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 1) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 2) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 3) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 4) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else if (rowIndex === 5) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 6) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 7) {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        } else if (columnIndex === 3) {
          if (rowIndex === 0) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 1) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 2) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 6) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 7) {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 1) {
					if (rowIndex === 0) {
						return {
							rowspan: 4,
							colspan: 1
						};
					} else if(rowIndex === 4){
						return {
							rowspan: 2,
							colspan: 1
						};
					} else{
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}	
			},
      headercellstyleTableDatas({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
        if (rowIndex === 0) {
          if (columnIndex === 1) {
            this.$nextTick(() => {
              if (document.getElementsByClassName(column.id).length !== 0) {
                document
                    .getElementsByClassName(column.id)[0]
                    .setAttribute('colSpan', 2);
              }
            });
          } else if (columnIndex === 2) {
            this.$nextTick(() => {
              if (document.getElementsByClassName(column.id).length !== 0) {
                document
                    .getElementsByClassName(column.id)[0]
                    .setAttribute('colSpan', 0);
              }
            });
          }
        }
      },
      spanmethodTableDatas({
                   row,
                   column,
                   rowIndex,
                   columnIndex
                 }) {
        if (columnIndex === 0) {
          if (rowIndex === 2) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else if (rowIndex === 3) {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        } else if (columnIndex === 1) {
          if (rowIndex === 0) {
            return {
              rowspan: 1,
              colspan: 2
            };
          } else if(rowIndex === 1){
            return {
              rowspan: 1,
              colspan: 2
            };
          } else if (rowIndex === 2) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else if (rowIndex === 3) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 4) {
            return {
              rowspan: 1,
              colspan: 2
            };
          } else if (rowIndex === 5) {
            return {
              rowspan: 1,
              colspan: 2
            };
          }
        } else if (columnIndex === 2) {
          if (rowIndex === 0) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if(rowIndex === 1){
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 4) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else if (rowIndex === 5) {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
      checkbox(e){
        if (e.sdsA_1_x_1.cellCode === "sdsA_1_0g_1" && e.sdsA_1_x_1.cellVal === 'N') {
          e.sdsA_1_x_3.cellVal = '';
          e.sdsA_1_x_3.cellVal1 = 'N';
          e.sdsA_1_x_3.cellVal2 = 'N';
          e.sdsA_1_x_3.cellVal3 = 'N';
        } else if (e.sdsA_1_x_1.cellCode === "sdsA_1_0e_1") {
          this.tableDatas[3].sdsA_1_x_1.cellVal = e.sdsA_1_x_1.cellVal;
          if (e.sdsA_1_x_1.cellVal === 'N') {
            e.sdsA_1_x_3.cellVal = '';
            this.tableDatas[3].sdsA_1_x_2.cellVal = 'N';
            this.tableDatas[3].sdsA_1_x_3.cellVal = '';
          }
          e.sdsA_1_x_2.cellVal = e.sdsA_1_x_1.cellVal;
          this.tableDatas[3].sdsA_1_x_2.cellVal = e.sdsA_1_x_1.cellVal;
        }
        if (e.sdsA_1_x_1.cellVal === 'N' || e.sdsA_1_x_2.cellVal === 'N') {
          e.sdsA_1_x_3.cellVal = '';
        }
      },
      radioChange(e) {
        if (e.sdsA_1_x_1.cellVal !== "2") {
          e.sdsA_1_x_2.cellVal = '';
        }
        e.sdsA_1_x_1.cellType = '1';
      }
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
